import {
    moveLibraryDocument,
    moveLibraryFolder,
    updateLibraryComparison,
    updateLibraryScope,
} from "@/api";

type MovableItemType = "document" | "scope" | "comparison" | "folder";

export function moveItemById(
    type: MovableItemType,
    id: number,
    folderId: number | null
) {
    switch (type) {
        case "document":
            return moveLibraryDocument(id, { target_folder_id: folderId });
        case "scope":
            return updateLibraryScope(id, { library_folder_id: folderId });
        case "comparison":
            return updateLibraryComparison(id, {
                library_folder_id: folderId,
            });
        case "folder":
            return moveLibraryFolder(id, { target_folder_id: folderId });
    }
}
